// ViewModalFiltersSection.jsx

import React from 'react';

// Components
import { buildDefaultFilter } from '../../viewModalFilters';
import ViewModalFilterRow from './ViewModalFilterRow';
import Button from 'components/button/Button';
import ModalField from 'components/modal/field/ModalField';
import ModalHint from 'components/modal/hint/ModalHint';
import ModalLabel from 'components/modal/label/ModalLabel';

/**
 * ViewModalFiltersSection
 *
 * Renders the Filters block inside ViewModal, including the header,
 * empty state messaging, and a list of filter rows.
 *
 * @returns {ReactNode} The rendered component.
 */
const ViewModalFiltersSection = ({
    isVisible = true,
    filters,
    setFilters,
    filterableFields,
    filterFieldMap,
    fieldOptions,
    theme,
    label = 'Filters',
    hint = 'Filters allow for refining the data according to specific criteria.',
    emptyHint = 'No filters added yet.',
    addButtonLabel = '+ Add Filter',
}) => {

    if (!isVisible) return null;

    // ----- RENDER ----- //

    return (

    <ModalField>

        <ModalLabel label={label} />
        <ModalHint hint={hint} />

        {filterableFields.length === 0 && (
            <ModalHint hint="No filterable fields available." />
        )}

        {filterableFields.length > 0 && filters.length === 0 && (
            <ModalHint hint={emptyHint} />
        )}

        {filters.length > 0 && (
            <div className="view-modal-rows">
                {filters.map((filter, index) => (
                    <ViewModalFilterRow
                      key={`filter_${index}`}
                      filter={filter}
                      index={index}
                      isLastRow={index === filters.length - 1}
                      fieldOptions={fieldOptions}
                      filterFieldMap={filterFieldMap}
                      setFilters={setFilters}
                      theme={theme}
                    />
                ))}
            </div>
        )}
        <div className="view-modal-add-button">
            <Button
              label={addButtonLabel}
              fontSize="12px"
              fontWeight="400"
              foregroundColor={theme.foregroundMuted}
              backgroundColor="transparent"
              height="30px"
              padding="0 10px"
              disabled={filterableFields.length === 0}
              onClick={() => setFilters((prev) => [...prev, buildDefaultFilter(filterableFields)])}
            />
        </div>

    </ModalField>
    );
};

// Dev Tools
ViewModalFiltersSection.displayName = 'ViewModalFiltersSection';

export default ViewModalFiltersSection;
